import { CLASSROOM_FEATURE_SWITCHES, SCHOOL_FEATURE_SWITCHES, USER_FEATURE_SWITCHES } from "./constants";

export type FeatureSwitchQuery = { [key: string]: string };

enum FeatureSwitchQueryGroupType {
  classroom = "class", // Switches specific to the current class. This will provide class specific functionality so must use the class id
}

export class FeatureSwitchQueryBuilder {
  static userSwitches = Object.values<string>(USER_FEATURE_SWITCHES);
  static schoolSwitches = Object.values<string>(SCHOOL_FEATURE_SWITCHES);
  static classroomSwitches = Object.values<string>(CLASSROOM_FEATURE_SWITCHES);

  static buildQuery(
    featureSetId: string,
    entityId: string,
    schoolId: string,
    classroomIds: string[]
  ): FeatureSwitchQuery {
    const query: FeatureSwitchQuery = {
      featureSetId,
    };

    if (FeatureSwitchQueryBuilder.userSwitches.length && entityId.length) {
      query.userId = entityId;
      query.userLocale = "en-US";
      query.userSwitches = FeatureSwitchQueryBuilder.userSwitches.join(",");
    }

    if (FeatureSwitchQueryBuilder.schoolSwitches.length && schoolId.length) {
      query.schoolId = schoolId;
      query.schoolSwitches = FeatureSwitchQueryBuilder.schoolSwitches.join(",");
    }

    for (const classroomId of classroomIds) {
      if (FeatureSwitchQueryBuilder.classroomSwitches.length) {
        FeatureSwitchQueryBuilder.addFeatureSwitchGroup(
          query,
          FeatureSwitchQueryGroupType.classroom,
          classroomId,
          FeatureSwitchQueryBuilder.classroomSwitches
        );
      }
    }
    return query;
  }

  private static addFeatureSwitchGroup(
    query: FeatureSwitchQuery,
    groupType: FeatureSwitchQueryGroupType,
    id: string,
    featureSwitches: string[]
  ) {
    const groupName = `${groupType}-${id}`;
    query[`${groupName}Id`] = id;
    query[`${groupName}Switches`] = featureSwitches.join(",");
  }
}
